import { Checkbox, DatePicker, Select, Typography } from 'antd';
import moment from 'moment';
import { IBestDataset, IPlotVariable } from '../../../../../../types/analytics';
import { DateFormat } from '../../../../../../utils/StaticVariable';
import styles from '../../Layout/AnalyticsLayout.module.scss';

const { Text } = Typography;

interface RosePlotInputFormProps {
  datasets: IBestDataset[];
  previewDatasetId: string;
  onDatasetChange: (datasetId: string) => void;
  categories: string[];
  variables: IPlotVariable[] | null;
  variable: IPlotVariable | null;
  onVariableChange: (variableIndex: number) => void;
  startDate: moment.Moment;
  endDate: moment.Moment;
  onStartDateChange: (date: moment.Moment | null) => void;
  onEndDateChange: (date: moment.Moment | null) => void;
  disabledStartDate: (date: moment.Moment) => boolean;
  disabledEndDate: (date: moment.Moment) => boolean;
  isForAllAnalytics: boolean;
  onCheckboxChange: () => void;
  isLoading?: boolean;
  hasError?: boolean;
}

export const RosePlotInputForm = ({
  datasets,
  previewDatasetId,
  onDatasetChange,
  categories,
  variables,
  variable,
  onVariableChange,
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  disabledStartDate,
  disabledEndDate,
  isForAllAnalytics,
  onCheckboxChange,
  isLoading = false,
  hasError = false,
}: RosePlotInputFormProps) => {
  return (
    <div className={styles.formRow}>
      <div className={`${styles.formItem} ${styles.datasetItem}`}>
        <Text>Dataset</Text>
        <Select
          id='Analytics-RosePlot-Dataset_Select'
          value={previewDatasetId}
          onChange={onDatasetChange}
          placeholder='Select dataset'
          disabled={isLoading}
        >
          {categories.map((category: string) => (
            <Select.OptGroup key={category} label={category}>
              {datasets
                .filter((item) => item.label === category)
                .map((item) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.value}
                  </Select.Option>
                ))}
            </Select.OptGroup>
          ))}
        </Select>
      </div>

      <div className={`${styles.formItem} ${styles.variableItem}`}>
        <Text>Variable</Text>
        <Select
          id='Analytics-RosePlot-Variable_Select'
          placeholder='Select variable'
          onChange={onVariableChange}
          value={variable?.Index ? variable.Index : 0}
          disabled={isLoading || hasError}
        >
          {variables
            ?.filter((item) => item.Name !== 'Time')
            .map((item) => (
              <Select.Option key={item.Index} value={item.Index}>
                {item.Name}
              </Select.Option>
            ))}
        </Select>
      </div>

      <div className={`${styles.formItem} ${styles.dateItem}`}>
        <Text>Start Date</Text>
        <DatePicker
          id='Analytics-RosePlot-StartDate_Input'
          value={moment(startDate)}
          disabledDate={disabledStartDate}
          onChange={onStartDateChange}
          format={DateFormat}
          disabled={isLoading || hasError}
        />
      </div>

      <div className={`${styles.formItem} ${styles.dateItem}`}>
        <Text>End Date</Text>
        <DatePicker
          id='Analytics-RosePlot-EndDate_Input'
          value={moment(endDate)}
          disabledDate={disabledEndDate}
          onChange={onEndDateChange}
          format={DateFormat}
          disabled={isLoading || hasError}
        />
      </div>

      <div className={`${styles.formItem} ${styles.checkboxItem}`}>
        <Checkbox
          id='Analytics-RosePlot_Checkbox'
          disabled={hasError || isLoading}
          checked={isForAllAnalytics}
          onChange={onCheckboxChange}
        />
        <Text onClick={onCheckboxChange} style={{ cursor: 'pointer' }}>
          Use this period for all analytics
        </Text>
      </div>
    </div>
  );
};

export type { RosePlotInputFormProps };
